export default __webpack_public_path__ + "static/media/spaymentsicon.54c5feef.svg";